import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McoLedgerLineList = ({ mcoLedger }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!mcoLedger) return;

      rowsReq.expr = ExprUtils.and(
        rowsReq.expr,
        ExprUtils.whereParams('earnedPeriodId', mcoLedger.earnedPeriodId, 'mcoLedgerId', mcoLedger.id),
      );
    },
    [mcoLedger?.id],
  );

  const augFieldDefs = (fieldToFieldDef) => {
    // 1. Dimensions
    fieldToFieldDef.earnedPeriodId.precedence = 1;
    fieldToFieldDef.earnedPeriodId.hasName = false;

    fieldToFieldDef.prodId.precedence = 2;
    fieldToFieldDef.prodId.hasName = false;

    fieldToFieldDef.planCustId.precedence = 2;
    fieldToFieldDef.planCustId.hasName = true;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;

    // 3. Quantities
    fieldToFieldDef.rbtQty.precedence = 2000;
    fieldToFieldDef.openDispQty.precedence = 2001;
    fieldToFieldDef.calcDispQty.precedence = 2002;
    fieldToFieldDef.dueQty.precedence = 2003;
    fieldToFieldDef.paidQty.precedence = 2004;

    // 4. Amounts
    fieldToFieldDef.rbtAmt.precedence = 3001;
    fieldToFieldDef.dispAmt.precedence = 4003;
    fieldToFieldDef.dueAmt.precedence = 3004;
    fieldToFieldDef.paidAmt.precedence = 3005;
  };

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Utlization Lines come from system only
  };

  return (
    <EntityList
      entity="MCO_LEDGER_LINE"
      augRowsReq={augRowsReq}
      augTabButtons={augTabButtons}
      augFieldDefs={augFieldDefs}
    />
  );
};
